import { render, staticRenderFns } from "./AddPDPage.vue?vue&type=template&id=54e6b70e&"
import script from "./AddPDPage.vue?vue&type=script&lang=js&"
export * from "./AddPDPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports